function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _jsxFileName = "/Users/vincent.limshowchen/Sites/account-components/src/components/FieldPass/index.js";
var _excluded = ["done", "title"],
  _excluded2 = ["done"],
  _excluded3 = ["followMoreLabel", "title"],
  _excluded4 = ["closeLabel", "Component", "contentProps", "footerProps", "onBack", "onNext", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { motion } from "framer-motion";
import merge from "lodash.merge";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { ButtonShapes, ButtonStyles } from "@mlb/react-patterns/dist/components/Button/button.types";
import Lightbox from "@mlb/react-patterns/dist/components/Lightbox/lightbox";
import COLORS from "@mlb/react-patterns/dist/style/universal.color";
import Login from "../Login";
import ManageFavoriteAndFollows from "../ManageFavoriteAndFollows";
import Register from "../Register";
import SelectFavoriteWithData from "../SelectFavoriteWithData";
import SelectFollows from "../SelectFollows";
import SelectPlayerFollows from "../SelectPlayerFollows";
import Footer from "./Footer";
import Header from "./Header";
import { Content, FieldPassContainer, FieldPassContent, FieldPassGlobalStyles } from "./styles";
import { ANIMATION_PROPS, DEFAULT_ENV } from "./utils";
var ComponentKey = "field-pass";
var DefaultDataAttr = {
  "data-testid": ComponentKey
};
var DefaultDataAttrBackdrop = {
  "data-testid": "".concat(ComponentKey, "__backdrop")
};
var DefaultDataAttrContent = {
  "data-testid": "".concat(ComponentKey, "__content-container")
};
export var FieldPassStates = {
  CLOSED: "CLOSED",
  CLOSING: "CLOSING",
  LOGIN: "LOGIN",
  REGISTER: "REGISTER",
  SELECT_FAVORITE: "SELECT_FAVORITE",
  SELECT_FOLLOWS: "SELECT_FOLLOWS",
  SELECT_PLAYER_FOLLOWS: "SELECT_PLAYER_FOLLOWS",
  MANAGE: "MANAGE"
};
export var FieldPassChangeReasons = {
  ACCOUNT_BUTTON_CLICKED: "ACCOUNT_BUTTON_CLICKED",
  BACK_BUTTON_CLICKED: "BACK_BUTTON_CLICKED",
  EMPTY_SECTION_CLICKED: "EMPTY_SECTION_CLICKED",
  FAVORITE_DELETE_CLICKED: "FAVORITE_DELETE_CLICKED",
  FAVORITE_REMOVED: "FAVORITE_REMOVED",
  FAVORITE_SELECTED: "FAVORITE_SELECTED",
  FOLLOW_BUTTON_CLICKED: "FOLLOW_BUTTON_CLICKED",
  FOLLOW_DELETE_CLICKED: "FOLLOW_DELETE_CLICKED",
  FOLLOW_FILTER_CLICKED: "FOLLOW_FILTER_CLICKED",
  FOLLOW_REMOVED: "FOLLOW_REMOVED",
  FOLLOW_SEARCH_CHANGE: "FOLLOW_SEARCH_CHANGE",
  FOLLOW_SEARCH_CLICKED: "FOLLOW_SEARCH_CLICKED",
  FOLLOW_TAB_CLICKED: "FOLLOW_TAB_CLICKED",
  FOLLOWS_REORDERED: "FOLLOWS_REORDERED",
  FOOTER_BUTTON_CLICKED: "FOOTER_BUTTON_CLICKED",
  LOGIN_ERROR: "LOGIN_ERROR",
  LOGIN_FAILURE: "LOGIN_FAILURE",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  REGISTER_ERROR: "REGISTER_ERROR",
  REGISTER_SUCCESS: "REGISTER_SUCCESS",
  STATE_CHANGE: "STATE_CHANGE"
};
export var FieldPassCloseReasons = {
  BACKDROP_CLICK: "backdropClick",
  CLOSE_BUTTON_CLICK: "closeButtonClick",
  ESCAPE_KEY_PRESS: "escapeKeyPress",
  FOOTER_CLICK: "FOOTER_CLICK",
  MISCONFIGURATION: "MISCONFIGURATION",
  SELF_CLOSE: "SELF_CLOSE"
};
var DefaultLightboxProps = {
  backdropProps: {
    dataAttr: DefaultDataAttrBackdrop
  },
  ContentComponent: FieldPassContent,
  contentProps: {
    dataAttr: DefaultDataAttrContent,
    variants: {
      hide: {
        y: "100vh",
        transition: {
          stiffness: 100
        }
      },
      show: {
        y: 0,
        transition: {
          stiffness: 100
        }
      }
    }
  },
  dataAttr: DefaultDataAttr,
  hideCloseButton: true
};
var DefaultCopyConfig = {
  closeLabel: "Close",
  loginTitle: "Log In",
  registerTitle: "Register",
  selectFavorite: {
    done: "Done",
    next: "Next",
    skip: "Skip",
    title: "Select a Favorite Team"
  },
  selectFollows: {
    done: "Done",
    followingLabel: "FOLLOWING",
    followLabel: "FOLLOW",
    noResultsCopy: "We're sorry, we couldn't find any results for",
    placeholderCopy: "Search Players & Teams",
    playersTabName: "Players",
    teamsTabName: "Teams",
    title: "Follow More Players & Teams"
  },
  selectPlayerFollows: {
    done: "Done",
    followingLabel: "FOLLOWING",
    followLabel: "FOLLOW"
  },
  manage: {
    favoriteTeamButtonLabel: "Select Favorite Team",
    favoriteTeamHeader: "Favorite Team",
    followedPlayersButtonLabel: "Select Followed Players",
    followedPlayersHeader: "Followed Players",
    followedTeamsButtonLabel: "Select Followed Teams",
    followedTeamsHeader: "Followed Teams",
    followMoreLabel: "Follow More Players & Teams",
    title: "Manage Your Players & Teams"
  }
};
var DefaultLoginConfig = {
  containerWidth: "100%",
  copyConfig: {
    passwordPlaceholder: "Create Password",
    registerLink: "Create New Account",
    submitButton: DefaultCopyConfig.loginTitle
  },
  features: {
    registration: true
  }
};
var DefaultRegisterConfig = {
  containerWidth: "100%",
  copyConfig: {
    confirmPasswordPlaceholder: "Repeat Password"
  },
  stacked: true
};
var FieldPass = function FieldPass(_ref) {
  var copyConfig = _ref.copyConfig,
    _ref$enableFaveAndFol = _ref.enableFaveAndFollow,
    enableFaveAndFollow = _ref$enableFaveAndFol === void 0 ? false : _ref$enableFaveAndFol,
    _ref$env = _ref.env,
    env = _ref$env === void 0 ? DEFAULT_ENV : _ref$env,
    favoriteTeam = _ref.favoriteTeam,
    followedPlayers = _ref.followedPlayers,
    followedTeams = _ref.followedTeams,
    _ref$isLoggedIn = _ref.isLoggedIn,
    isLoggedIn = _ref$isLoggedIn === void 0 ? false : _ref$isLoggedIn,
    isOpen = _ref.isOpen,
    lightboxProps = _ref.lightboxProps,
    loginConfig = _ref.loginConfig,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {
      return null;
    } : _ref$onChange,
    onClose = _ref.onClose,
    registerConfig = _ref.registerConfig;
  var _useState = useState({
      current: FieldPassStates.CLOSED
    }),
    _useState2 = _slicedToArray(_useState, 2),
    fieldPassState = _useState2[0],
    setState = _useState2[1];
  var setFieldPassState = function setFieldPassState(current) {
    return setState({
      current: current,
      previous: fieldPassState.current
    });
  };
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    selectPlayerFollowsTeam = _useState4[0],
    setSelectPlayerFollowsTeam = _useState4[1];
  var contentRef = useRef();
  var onFieldPassChange = function onFieldPassChange(data) {
    return onChange(_objectSpread(_objectSpread({}, data), {}, {
      state: _objectSpread({}, fieldPassState)
    }));
  };
  var onFieldPassClose = function onFieldPassClose(data) {
    return onClose(_objectSpread(_objectSpread({}, data), {}, {
      state: _objectSpread({}, fieldPassState)
    }));
  };
  useEffect(function () {
    onChange({
      reason: FieldPassChangeReasons.STATE_CHANGE,
      state: fieldPassState
    });
  }, [fieldPassState.current]);

  /**
   * This useEffect's focus is to determine which FieldPassState the user should see first.
   * - if not logged in => LOGIN
   * - else if enableFaveAndFollow
   *   - if no fave => select flow (SELECT_FAVORITE state)
   *   - if fave => manage flow (MANAGE state)
   */
  useEffect(function () {
    if (isOpen) {
      if (!isLoggedIn) {
        /**
         * If a user switches to REGISTER, closes FieldPass and reopens, the state will persist as REGISTER
         */
        var current = fieldPassState.previous === FieldPassStates.REGISTER ? FieldPassStates.REGISTER : FieldPassStates.LOGIN;
        setFieldPassState(current);
      } else if (enableFaveAndFollow) {
        var _current = favoriteTeam ? FieldPassStates.MANAGE : FieldPassStates.SELECT_FAVORITE;
        setFieldPassState(_current);
      }
    }
  }, [enableFaveAndFollow, isLoggedIn, isOpen]);

  /**
   * This useEffect's focus is to determine and handle when FieldPass should close itself.
   * - After a successful authentication (isLoggedIn changes)
   * - `onFieldPassClose` is triggered -- due to one of the FieldPassCloseReasons
   */
  useEffect(function () {
    if (isOpen) {
      if (isLoggedIn && !enableFaveAndFollow) {
        /**
         * After a successful Login or Registration, those components automatically
         * change their UI to display a success message. We do not want that for FieldPass.
         * So to work around, we'll switch to the CLOSING state which will display _nothing_.
         */
        if (fieldPassState.current === FieldPassStates.LOGIN || fieldPassState.current === FieldPassStates.REGISTER) {
          setFieldPassState(FieldPassStates.CLOSING);
        } else if (fieldPassState.current === FieldPassStates.CLOSING) {
          /**
           * We don't want to show any post-success UI (for now), so immediately trigger onFieldPassClose
           */
          onFieldPassClose({
            message: "Login or Registration has succeeded. Closing smoothly... FieldPass out!",
            reason: FieldPassCloseReasons.SELF_CLOSE
          });
          var timeoutId = setTimeout(function () {
            // eslint-disable-next-line
            console.warn("⚠️ [FieldPass] Misconfiguration: make sure your `onClose` function changes the `isOpen` value to false");
            setFieldPassState(FieldPassStates.CLOSED);
          }, 300);
          return function () {
            return clearTimeout(timeoutId);
          };
        } else {
          /**
           * The external implementation is likely incorrect and nothing will occur visually, so signal
           */
          onFieldPassClose({
            message: "Are you trying to open FieldPass when `isLoggedIn` is true?",
            reason: FieldPassCloseReasons.MISCONFIGURATION
          });
        }
      }
    } else if (fieldPassState.current !== FieldPassStates.CLOSED) {
      var _timeoutId = setTimeout(function () {
        return setFieldPassState(FieldPassStates.CLOSED);
      }, 300);
      return function () {
        return clearTimeout(_timeoutId);
      };
    }
  }, [enableFaveAndFollow, fieldPassState.current, isLoggedIn, isOpen, onFieldPassClose]);

  /**
   * Memoize props for:
   * 1) Lightbox (lightboxProps)
   * 2) FieldPass Copy (copyConfig)
   * 3) Login (loginProps)
   * 4) Register (registerProps)
   * ---
   * These are the props that can be determined statically at runtime as a combination of:
   * - default configs (built-in)
   * - any props provided for custom implementation,
   * - additional props for derived from runtime props & state, e.g. Component, title, callbacks
   */
  var combinedLightboxProps = useMemo(function () {
    return merge(DefaultLightboxProps, lightboxProps);
  }, [lightboxProps]);
  var combinedCopyConfig = useMemo(function () {
    return merge(DefaultCopyConfig, copyConfig);
  }, [copyConfig]);
  var combinedLoginProps = useMemo(function () {
    return merge(DefaultLoginConfig, loginConfig, {
      closeLabel: combinedCopyConfig.closeLabel,
      Component: Login,
      onError: function onError(error) {
        return onFieldPassChange({
          error: error,
          reason: FieldPassChangeReasons.LOGIN_ERROR
        });
      },
      onFailure: function onFailure() {
        return onFieldPassChange({
          reason: FieldPassChangeReasons.LOGIN_FAILURE
        });
      },
      onSuccess: function onSuccess(tokens) {
        return onFieldPassChange({
          data: tokens,
          reason: FieldPassChangeReasons.LOGIN_SUCCESS
        });
      },
      setAccountType: function setAccountType() {
        onFieldPassChange({
          reason: FieldPassChangeReasons.ACCOUNT_BUTTON_CLICKED
        });
        setFieldPassState(FieldPassStates.REGISTER);
      },
      title: combinedCopyConfig.loginTitle
    });
  }, [combinedCopyConfig, loginConfig, onFieldPassChange]);
  var combinedRegisterProps = useMemo(function () {
    return merge(DefaultRegisterConfig, registerConfig, {
      closeLabel: combinedCopyConfig === null || combinedCopyConfig === void 0 ? void 0 : combinedCopyConfig.closeLabel,
      Component: Register,
      onError: function onError(error) {
        return onFieldPassChange({
          error: error,
          reason: FieldPassChangeReasons.REGISTER_ERROR
        });
      },
      onSuccess: function onSuccess() {
        return onFieldPassChange({
          reason: FieldPassChangeReasons.REGISTER_SUCCESS
        });
      },
      setAccountType: function setAccountType() {
        onFieldPassChange({
          reason: FieldPassChangeReasons.ACCOUNT_BUTTON_CLICKED
        });
        setFieldPassState(FieldPassStates.LOGIN);
      },
      title: combinedCopyConfig.registerTitle
    });
  }, [combinedCopyConfig, onFieldPassChange, registerConfig]);

  /**
   * Since Component is derived dynamically from FieldPassState, this function provides a method to
   * get the props needed for _only_ that state. This helps to separate concerns and avoid providing
   * props that may be irrelevant for a given state.
   * ---
   * For now, this is wonderfully simple because the Auth states can be statically determined.
   * Future states for Favorite/Follows will likely be more complex due to user data dependencies
   */
  var getPropsForState = function getPropsForState(state) {
    switch (state) {
      case FieldPassStates.CLOSING:
        /**
         * See comments in useEffect for more context.
         * This means when the current FieldPassState is CLOSING, we'll render nothing within the content (Component),
         * but it will close immediately and not be perceived by the user.
         *
         * If we wanted to show something different before closing, we'd add the component here and update the useEffect
         * to not fire `onFieldPassClose` immediately.
         */
        return {
          Component: function Component() {
            return null;
          }
        };
      case FieldPassStates.LOGIN:
        return combinedLoginProps;
      case FieldPassStates.REGISTER:
        return combinedRegisterProps;
      case FieldPassStates.SELECT_FAVORITE:
        {
          var copy = combinedCopyConfig.selectFavorite;
          var cameFromManage = fieldPassState.previous === FieldPassStates.MANAGE;
          var _footerProps = cameFromManage ? {
            label: copy.done,
            shape: ButtonShapes.PILL_SOLID
          } : {
            label: favoriteTeam ? copy.next : copy.skip,
            shape: favoriteTeam ? ButtonShapes.PILL_SOLID : ButtonShapes.PILL
          };
          return {
            closeLabel: combinedCopyConfig === null || combinedCopyConfig === void 0 ? void 0 : combinedCopyConfig.closeLabel,
            Component: SelectFavoriteWithData,
            env: env,
            favoriteId: favoriteTeam === null || favoriteTeam === void 0 ? void 0 : favoriteTeam.id,
            footerProps: _footerProps,
            onBack: cameFromManage && function (event) {
              onFieldPassChange({
                event: event,
                reason: FieldPassChangeReasons.BACK_BUTTON_CLICKED
              });
              setFieldPassState(FieldPassStates.MANAGE);
            },
            onClick: function onClick(event, team) {
              return onFieldPassChange({
                data: team,
                event: event,
                reason: FieldPassChangeReasons.FAVORITE_SELECTED
              });
            },
            onNext: function onNext(event) {
              onFieldPassChange({
                event: event,
                reason: FieldPassChangeReasons.FOOTER_BUTTON_CLICKED
              });
              if (cameFromManage) {
                onFieldPassClose({
                  event: event,
                  message: "".concat(copy.done, " button clicked"),
                  reason: FieldPassCloseReasons.FOOTER_CLICK
                });
              } else {
                setFieldPassState(FieldPassStates.SELECT_FOLLOWS);
              }
            },
            title: copy.title
          };
        }
      case FieldPassStates.SELECT_FOLLOWS:
        {
          var _combinedCopyConfig$s = combinedCopyConfig.selectFollows,
            done = _combinedCopyConfig$s.done,
            _title = _combinedCopyConfig$s.title,
            _copy = _objectWithoutProperties(_combinedCopyConfig$s, _excluded);
          return _objectSpread({
            closeLabel: combinedCopyConfig === null || combinedCopyConfig === void 0 ? void 0 : combinedCopyConfig.closeLabel,
            Component: SelectFollows,
            contentProps: {
              isScrollable: false
            },
            env: env,
            favoriteId: favoriteTeam === null || favoriteTeam === void 0 ? void 0 : favoriteTeam.id,
            followedPlayers: followedPlayers,
            followedTeams: followedTeams,
            footerProps: {
              label: done,
              shape: ButtonShapes.PILL_SOLID
            },
            onBack: function onBack(event) {
              var current = fieldPassState.previous === FieldPassStates.MANAGE ? FieldPassStates.MANAGE : FieldPassStates.SELECT_FAVORITE;
              onFieldPassChange({
                event: event,
                reason: FieldPassChangeReasons.BACK_BUTTON_CLICKED
              });
              setFieldPassState(current);
            },
            onFilterClick: function onFilterClick(event, team) {
              setSelectPlayerFollowsTeam(team);
              onFieldPassChange({
                data: team,
                event: event,
                reason: FieldPassChangeReasons.FOLLOW_FILTER_CLICKED
              });
              setFieldPassState(FieldPassStates.SELECT_PLAYER_FOLLOWS);
            },
            onFollowClick: function onFollowClick(event, data) {
              return onFieldPassChange({
                data: data,
                event: event,
                reason: FieldPassChangeReasons.FOLLOW_BUTTON_CLICKED
              });
            },
            onNext: function onNext(event) {
              onFieldPassChange({
                event: event,
                reason: FieldPassChangeReasons.FOOTER_BUTTON_CLICKED
              });
              onFieldPassClose({
                event: event,
                message: "".concat(done, " button clicked"),
                reason: FieldPassCloseReasons.FOOTER_CLICK
              });
            },
            onSearchChange: function onSearchChange(event, query) {
              return onFieldPassChange({
                data: query,
                event: event,
                reason: FieldPassChangeReasons.FOLLOW_SEARCH_CHANGE
              });
            },
            onSearchClick: function onSearchClick(event, query) {
              return onFieldPassChange({
                data: query,
                event: event,
                reason: FieldPassChangeReasons.FOLLOW_SEARCH_CLICKED
              });
            },
            onTabClick: function onTabClick(event, tabName) {
              return onFieldPassChange({
                data: tabName,
                event: event,
                reason: FieldPassChangeReasons.FOLLOW_TAB_CLICKED
              });
            },
            title: _title
          }, _copy);
        }
      case FieldPassStates.SELECT_PLAYER_FOLLOWS:
        {
          var _combinedCopyConfig$s2 = combinedCopyConfig.selectPlayerFollows,
            _done = _combinedCopyConfig$s2.done,
            _copy2 = _objectWithoutProperties(_combinedCopyConfig$s2, _excluded2);
          return _objectSpread({
            closeLabel: combinedCopyConfig === null || combinedCopyConfig === void 0 ? void 0 : combinedCopyConfig.closeLabel,
            Component: SelectPlayerFollows,
            env: env,
            followedPlayers: followedPlayers,
            footerProps: {
              label: _done,
              shape: ButtonShapes.PILL_SOLID
            },
            onBack: function onBack(event) {
              onFieldPassChange({
                event: event,
                reason: FieldPassChangeReasons.BACK_BUTTON_CLICKED
              });
              setFieldPassState(fieldPassState.previous);
            },
            onClick: function onClick(event, player) {
              return onFieldPassChange({
                data: player,
                event: event,
                reason: FieldPassChangeReasons.FOLLOW_BUTTON_CLICKED
              });
            },
            onNext: function onNext(event) {
              onFieldPassChange({
                event: event,
                reason: FieldPassChangeReasons.FOOTER_BUTTON_CLICKED
              });
              onFieldPassClose({
                event: event,
                message: "".concat(_done, " button clicked"),
                reason: FieldPassCloseReasons.FOOTER_CLICK
              });
            },
            teamId: selectPlayerFollowsTeam === null || selectPlayerFollowsTeam === void 0 ? void 0 : selectPlayerFollowsTeam.id,
            title: "".concat((selectPlayerFollowsTeam === null || selectPlayerFollowsTeam === void 0 ? void 0 : selectPlayerFollowsTeam.superName) === "Athletics" ? "" : selectPlayerFollowsTeam === null || selectPlayerFollowsTeam === void 0 ? void 0 : selectPlayerFollowsTeam.superName, " ").concat(selectPlayerFollowsTeam === null || selectPlayerFollowsTeam === void 0 ? void 0 : selectPlayerFollowsTeam.name)
          }, _copy2);
        }
      case FieldPassStates.MANAGE:
        {
          var _combinedCopyConfig$m = combinedCopyConfig.manage,
            followMoreLabel = _combinedCopyConfig$m.followMoreLabel,
            _title2 = _combinedCopyConfig$m.title,
            _copy3 = _objectWithoutProperties(_combinedCopyConfig$m, _excluded3);
          return _objectSpread({
            closeLabel: combinedCopyConfig === null || combinedCopyConfig === void 0 ? void 0 : combinedCopyConfig.closeLabel,
            Component: ManageFavoriteAndFollows,
            contentProps: {
              layoutScroll: true
            },
            favoriteTeam: favoriteTeam,
            followedPlayers: followedPlayers,
            followedTeams: followedTeams,
            footerProps: {
              buttonProps: {
                additionalProps: {
                  style: {
                    color: COLORS.linkBlue,
                    borderRadius: "8px",
                    height: "100%",
                    transition: "none"
                  }
                },
                iconColor: COLORS.linkBlue,
                iconLeft: false,
                iconName: "arrow-next",
                iconSize: 12,
                styleName: ButtonStyles.DEFAULT
              },
              label: followMoreLabel,
              shape: ButtonShapes.SOLID
            },
            onFavoriteDeleteClick: function onFavoriteDeleteClick(event, team) {
              return onFieldPassChange({
                data: team,
                event: event,
                reason: FieldPassChangeReasons.FAVORITE_DELETE_CLICKED
              });
            },
            onFavoriteRemove: function onFavoriteRemove(event, team) {
              return onFieldPassChange({
                data: team,
                event: event,
                reason: FieldPassChangeReasons.FAVORITE_REMOVED
              });
            },
            onFollowDeleteClick: function onFollowDeleteClick(event, item) {
              return onFieldPassChange({
                data: item,
                event: event,
                reason: FieldPassChangeReasons.FOLLOW_DELETE_CLICKED
              });
            },
            onFollowRemove: function onFollowRemove(event, item) {
              return onFieldPassChange({
                data: item,
                event: event,
                reason: FieldPassChangeReasons.FOLLOW_REMOVED
              });
            },
            onNext: function onNext(event) {
              onFieldPassChange({
                event: event,
                reason: FieldPassChangeReasons.FOOTER_BUTTON_CLICKED
              });
              setFieldPassState(FieldPassStates.SELECT_FOLLOWS);
            },
            onReorder: function onReorder(data) {
              onFieldPassChange({
                data: data,
                reason: FieldPassChangeReasons.FOLLOWS_REORDERED
              });
            },
            onSelectFavoriteClick: function onSelectFavoriteClick(event, data) {
              onFieldPassChange({
                data: data,
                event: event,
                reason: FieldPassChangeReasons.EMPTY_SECTION_CLICKED
              });
              setFieldPassState(FieldPassStates.SELECT_FAVORITE);
            },
            onSelectFollowClick: function onSelectFollowClick(event, data) {
              onFieldPassChange({
                data: data,
                event: event,
                reason: FieldPassChangeReasons.EMPTY_SECTION_CLICKED
              });
              setFieldPassState(FieldPassStates.SELECT_FOLLOWS);
            },
            title: _title2
          }, _copy3);
        }
      default:
        return null;
    }
  };
  var propsForState = getPropsForState(fieldPassState.current);
  if (!propsForState) {
    return null;
  }
  var closeLabel = propsForState.closeLabel,
    Component = propsForState.Component,
    contentProps = propsForState.contentProps,
    footerProps = propsForState.footerProps,
    onBack = propsForState.onBack,
    onNext = propsForState.onNext,
    title = propsForState.title,
    props = _objectWithoutProperties(propsForState, _excluded4);
  return /*#__PURE__*/React.createElement(Lightbox, _extends({
    isOpen: isOpen,
    onClose: onFieldPassClose
  }, combinedLightboxProps, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 659,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(FieldPassGlobalStyles, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 664,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(FieldPassContainer, {
    layout: true,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 665,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Header, {
    as: motion.div,
    componentKey: ComponentKey,
    layout: true,
    onBack: onBack,
    onClose: onFieldPassClose,
    title: title,
    closeLabel: closeLabel,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 666,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(Content, _extends({}, contentProps, {
    ref: contentRef,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 675,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(Component, _extends({
    containerProps: ANIMATION_PROPS
  }, props, {
    contentRef: contentRef,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 676,
      columnNumber: 11
    }
  }))), onNext && /*#__PURE__*/React.createElement(Footer, _extends({
    as: motion.div,
    componentKey: ComponentKey,
    onClick: onNext
  }, footerProps, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 683,
      columnNumber: 11
    }
  }))));
};
export default /*#__PURE__*/React.memo(FieldPass);